export default "__VITE_ASSET__CXV9Djpu__"